<template>
  <el-table class="batch-transfer-table common-el-table-styles" height="320" :data="list" border ref="tableRef">
    <el-table-column label="序号">
      <template slot-scope="{ $index }">
        <div>{{ $index + 1 }}</div>
      </template>
    </el-table-column>
    <el-table-column label="转入账号" class-name="parent-col">
      <el-table-column prop="accountId" label="账号ID" show-overflow-tooltip></el-table-column>
      <el-table-column prop="adAccount" label="账号名称" show-overflow-tooltip></el-table-column>
      <el-table-column prop="advertiserId" label="计划主ID" show-overflow-tooltip></el-table-column>
      <el-table-column prop="mediaName" label="媒体" show-overflow-tooltip></el-table-column>
      <el-table-column prop="opNames" label="管理人" show-overflow-tooltip></el-table-column>
      <el-table-column prop="agentName" label="代理商"></el-table-column>
      <el-table-column prop="accountMoney" label="实时账面余额" width="90"></el-table-column>

      <el-table-column label="转账方式" width="120">
        <template slot-scope="{ row }">
          <el-select style="width: 100%" v-model="row.isSelfDeal">
            <el-option
              v-for="item in [
                { label: '自行转账', value: 1 },
                { label: '财务转账', value: 0 }
              ]"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </template>
      </el-table-column>

      <el-table-column label="转入账面金额" width="120">
        <template slot-scope="{ row }">
          <el-input v-model="row.transferBalance" placeholder="请输入金额"></el-input>
        </template>
      </el-table-column>
    </el-table-column>

    <el-table-column label="转出账号" class-name="parent-col transfer-bg-highlight">
      <el-table-column class-name="transfer-bg-highlight" label="转出账号" width="180">
        <template slot-scope="{ row, $index }">
          <el-select
            style="width: 100%"
            class="account-selector"
            filterable
            v-model="row.transferAccountId"
            :loading="row.loading"
            @focus="onAccoutSelectorFocus(row, $index)"
            @change="onRowTransferAccountChange($event, row, $index)"
          >
            <el-option v-for="item in getAvailableAccounts()[row.accountId]" :label="item.adAccount" :key="item.id" :value="item.id">
              <span>{{ item.adAccount }}</span>
              <span v-if="item.accountMoney">&ensp;余额：{{ item.accountMoney }}</span>
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        class-name="transfer-bg-highlight"
        prop="transferAccountInfo.mediaName"
        label="媒体"
        show-overflow-tooltip
      ></el-table-column>

      <el-table-column v-if="showSpecialCols" width="130" class-name="transfer-bg-highlight" label="转出资金类型">
        <template slot-scope="{ row }">
          <!-- 腾讯广告 -->
          <el-select class="fund-type-selector" v-if="row.mediaId === mediaTypeEnum.GDT" v-model="row.transferFundType" style="width: 100%">
            <el-option v-for="item in gdtFundType" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>

          <!-- 头条 -->
          <el-select
            class="fund-type-selector"
            v-if="row.mediaId === mediaTypeEnum.TOUTIAO"
            v-model="row.transferFundType"
            style="width: 100%"
          >
            <el-option v-for="item in toutiaoFundType" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </template>
      </el-table-column>

      <el-table-column class-name="transfer-bg-highlight" label="实时总余额" width="150" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <!-- 头条、腾讯广告取接口获取的字段 -->
          <span v-if="showSpecialCols">{{ row.realtimeBalance.total_transfer_balance }}</span>
          <!-- 其他的媒体取列表带的字段 -->
          <span v-else>{{ row.accountMoney }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="showSpecialCols"
        class-name="transfer-bg-highlight"
        prop="realtimeBalance.bid_prepay_valid"
        label="现金余额"
      ></el-table-column>
      <el-table-column
        v-if="showSpecialCols"
        class-name="transfer-bg-highlight"
        prop="realtimeBalance.bid_credit_valid"
        label="授信余额"
      ></el-table-column>

      <el-table-column
        v-if="showSpecialCols"
        class-name="transfer-bg-highlight"
        prop="realtimeBalance.grant_valid"
        label="赠送余额"
      ></el-table-column>

      <el-table-column
        v-if="showSpecialCols"
        class-name="transfer-bg-highlight"
        prop="realtimeBalance.virturl_valid"
        label="补偿虚拟金"
      ></el-table-column>

      <el-table-column
        v-if="showSpecialCols"
        class-name="transfer-bg-highlight"
        prop="realtimeBalance.special_gift_valid"
        label="专项充值金"
      ></el-table-column>
      <el-table-column class-name="transfer-bg-highlight" prop="transferAccountInfo.opNames" label="管理人员"></el-table-column>
      <el-table-column class-name="transfer-bg-highlight" prop="transferAccountInfo.agentName" label="代理商" width="150">
      </el-table-column>
    </el-table-column>

    <el-table-column label="操作" fixed="right">
      <template slot-scope="{ $index }">
        <el-button type="text" @click="removeRow($index)">移除</el-button>
        <el-button type="text" @click="copyRow($index)">复制</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { getValidTransferAccounts, getTransferAccountBalance } from '@/api/ptom.data.model'
import { gdtFundType, toutiaoFundType, toutiaoFundTypeEnum, gdtFundTypeEnum, mediaTypeEnum } from './data.js'
import { clone } from '@/common/js/just.js'

export default {
  name: 'transferIn',
  props: {
    list: {
      type: Array
    }
  },
  inject: ['getAccountRealtimeBalance', 'updateTableRow', 'getAvailableAccounts'],
  data() {
    return {
      gdtFundType,
      toutiaoFundType,
      toutiaoFundTypeEnum,
      gdtFundTypeEnum,
      mediaTypeEnum
    }
  },
  computed: {
    hasToutiao() {
      return this.list.some((item) => item.mediaId === mediaTypeEnum.TOUTIAO)
    },
    hasGdt() {
      return this.list.some((item) => item.mediaId === mediaTypeEnum.GDT)
    },
    showSpecialCols() {
      return this.hasGdt || this.hasToutiao
    }
  },
  created() {},
  methods: {
    /**
     * @description: 点击账号选择器获取可用账号
     * @param {*} row
     * @param {*} idx
     */
    onAccoutSelectorFocus(row, idx) {
      this.updateTableRow(row, idx)
    },
    /**
     * @description: 当选择转出账号时，获取转出账号的信息
     * @param {*} e
     * @param {*} row
     */
    async onRowTransferAccountChange(e, row, idx) {
      // 找到当前转出账号信息
      const availableAccounts = this.getAvailableAccounts()
      const transferAccountInfo = availableAccounts[row.accountId].find((item) => item.id === e)

      const newList = []

      for (let i = 0; i < this.list.length; i++) {
        const item = this.list[i]

        if (i === idx) {
          // 只处理腾讯广告、头条的情况，获取账号余额
          if ([mediaTypeEnum.TOUTIAO, mediaTypeEnum.GDT].includes(item.mediaId)) {
            const realtimeBalance = await this.getAccountRealtimeBalance(item, row.transferAccountId)

            // transferAccountInfo 注入到当前行，用于表格转出账号显示
            newList.push({ ...item, realtimeBalance, transferAccountInfo })
          } else {
            newList.push({ ...item, transferAccountInfo })
          }
          continue
        }

        newList.push(item)
      }

      this.$emit('update-list', newList)
    },

    /**
     * @description: 批量设置平台类型列
     */
    onGlobalBalanceClear() {
      const newList = this.list.map((item) => ({ ...item, balance: '' }))
      this.$emit('update-list', newList)
    },
    /**
     * @description: 移除一行
     */
    removeRow(idx) {
      const newList = this.list.filter((_, i) => i !== idx)
      this.$emit('update-list', newList)
    },
    /**
     * @description: 复制一行
     */
    copyRow(idx) {
      const newList = clone(this.list)
      newList.splice(idx, 0, this.list[idx])
      this.$emit('update-list', newList)
    }
  }
}
</script>

<style lang="scss">
.batch-transfer-table {
  thead .transfer-bg-highlight {
    background: rgb(214, 235, 255) !important;
  }
  thead .parent-col {
    .cell {
      justify-content: center;
      font-weight: 700;
    }
  }
}
</style>
